import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Three = styled.div.withConfig({
  displayName: "partials__Three",
  componentId: "sc-l0c900-0"
})(["display:grid;grid-template-columns:1fr 1fr 1fr;gap:36px;", ""], maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
export var TagBlock = styled.div.withConfig({
  displayName: "partials__TagBlock",
  componentId: "sc-l0c900-1"
})(["display:flex;flex-flow:column;", ""], maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    &:not(:first-child) {\n      margin-top: 56px;\n    }\n  "]))));
export var TagBottomBlock = styled.div.withConfig({
  displayName: "partials__TagBottomBlock",
  componentId: "sc-l0c900-2"
})(["margin-top:auto;"]);
export var TagTitle = styled.h6.withConfig({
  displayName: "partials__TagTitle",
  componentId: "sc-l0c900-3"
})(["display:block;margin-bottom:32px;font-weight:700;color:", ";", ";text-transform:uppercase;&:after{display:block;position:absolute;width:56px;height:3px;border-radius:6px;margin-top:3px;content:'';background-color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryD;
}, getFont(1), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
});